<div class="input-group">
  <ng-content select=".input-group-prepend"></ng-content>
  <ng-template #rt let-r="result">
    <span [ngStyle]="styling(r)">{{ $any(inputFormatter)(r) }}</span>
  </ng-template>
  <ng-template #newValueFromInputTextTemplate let-r="result">
    @if (r['$isNewValueRecord']) {
      <span>
        <span class="fa fa-light fa-plus me-2"></span>
        <span>{{ newValueFromInputText }}</span>
      </span>
    } @else {
      <span>{{ $any(resultFormatter)(r) }}</span>
    }
  </ng-template>
  <input #inputField [(ngModel)]="inputModel" (ngModelChange)="!$event ? onBlur() : null"
         [typeahead]="onInput" [resultFormatter]="$any(resultFormatter)" [ngClass]="cssClass ? cssClass : undefined"
         (selectItem)="onSelect($event.item)" (deleteItem)="onDelete($event.item)" [inputFormatter]="$any(inputFormatter)"
         [resultTemplate]="styling ? rt : resultTemplate ? resultTemplate : newValueFromInputText ? newValueFromInputTextTemplate : null" [minCharacters]="minCharacters"
         [minCharacters]="minCharacters"
         (focus)="onFocus()" (blur)="onBlur()" (input)="clear($event)"
         [attr.disabled]="disabled ? true : null" [placeholder]="placeholder" [id]="id ? id + '-input' : ''"
         [required]="required" autocomplete="chrome-off" [showDelete]="showDelete"
         [attr.type]="searching || appContext.useNewLookAndFeel() ? 'text' : 'search'"
         class="form-control rounded-end"/>
  @if (!inputModel || inputModel.requiresEditing) {
    <span class="input-group-text border-start-0 search-icon bg-transparent rounded-end"
          (click)="inputField.focus()">
      <span
        class="fa-light {{newValueTemplate || newValueFromInputFunction ? 'fa-search-plus' : isSelect ? 'fa-chevron-down' : 'fa-search'}}"></span>
    </span>
  }
  @if (inputModel && appContext.useNewLookAndFeel() && !searching && !disabled) {
    <button class="input-group-text border-start-0 reset-icon bg-transparent rounded-end"
            (click)="onSelect(null)">
      <span class="fa-light fa-xmark-large"></span>
    </button>
  }
  @if (searching && inputModel) {
    <span class="input-group-text border-0 search-icon bg-transparent">
      <span class="spinner-border spinner-border-sm text-secondary" role="status"></span>
    </span>
  }
</div>
<ng-content select=".invalid-feedback"></ng-content>
<ng-content select=".valid-feedback"></ng-content>

@if (newValueTemplate && inputModel?.requiresEditing === true) {
  <div #newValueModal class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" [ngClass]="newValueModalClass" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ 'Edit ' + valueType }}</h5>
          <button type="button" class="btn-close" (click)="onCancelEditing()" aria-label="Close">
          </button>
        </div>
        <div class="modal-body">
          <form (ngSubmit)="onCompleteEditing() ? null : $event.stopPropagation();">
            <ng-container [ngTemplateOutlet]="newValueTemplate"
                          [ngTemplateOutletContext]="{model : inputModel}"></ng-container>
            <div class="row justify-content-between">
              <div class="col-auto">
                <button class="btn btn-secondary me-auto" type="button"
                        style="min-width: 8rem" (click)="onCancelEditing()">Cancel
                </button>
              </div>
              <div class="col-auto">
                <button class="btn btn-info ms-auto" type="submit" style="min-width: 8rem">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
